const StatusMensagem = {
  NaoEnviada: 0,
  Enviando: 1,
  Enviada: 2,
  RecebidaLida: 3,
  RecebidaNaoLida: 4
};

export default StatusMensagem;
